import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authSlice from "../slices/authSlice";
import pageSlice from "../slices/PageSlice";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import searchSlice from "../slices/searchSlice";
import fileUploadSlice from "../slices/fileUploadSlice";
import listSlice from "../slices/listSlice";
import clinicSlice from "../slices/clinicSlice";

const reducers = combineReducers({
  authSlice,
  pageSlice,
  searchSlice,
  fileUploadSlice,
  listSlice,
  clinicSlice,
});

const persistConfig = {
  key: "root",
  storage,
  version: 1,
  blacklist: [
    "authSlice",
    "pageSlice",
    "searchSlice",
    "fileUploadSlice",
    "listSlice",
  ],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
